/**
 * Legacy way to determine if in basket page.
 * TODO: Rather do a condition in BE code to not have to call this check. Then remove ASAP.
 * @deprecated
 */
export const isInShoppingPage = () => window.location.pathname.split('/').includes('shopping');
